import { FC } from "react"
import cx from "classnames"
import { AiFillFileText } from "react-icons/ai"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const TextFileIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <AiFillFileText
      className={cx("w-5 h-5 transition-opacity", className)}
      {...rest}
    />
  )
}

export default TextFileIcon
